<template>
    <router-link to="/live-class" tag="li"
        ><a
            ><i class="fa fa-podcast"></i> <span>Live class</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "live-class",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?3876f391